import React from "react";

export function UserAvatar({ name, size = 32 }) {
  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word[0]?.toUpperCase())
      .join("")
      .slice(0, 2);
  };

  const initials = getInitials(name);

  return (
    <div
      className="flex items-center justify-center rounded-full text-white font-semibold bg-gradient-to-br from-[#0052FF] to-[#0099FF]"
      style={{
        width: size,
        height: size,
        fontSize: size * 0.4, // dynamically scale text
      }}
      title={name}
    >
      {initials}
    </div>
  );
}